import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CustomNavbar from "../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../components/SidebarDashboard";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  Row,
  Col,
  Form,
  Spinner,
  Dropdown,
} from "react-bootstrap";
import toastr from "toastr";
import moment from "moment";

//redux
import {
  editFormEvalCompetencia,
  getFormEvalCompeteciaById,
  sendNotifications,
  sendOverviewNotifications,
} from "../../redux/evaluacion_desempenio/FormularioEval_Competencia/actions";
import ResumenColaborador from "../../components/evaluacion_desempenio/ResumenColaborador";
import messages from "../../redux/messages";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import ResumenColaboradorCompleto from "../../components/evaluacion_desempenio/ResumenColaboradorCompleto";

const EvalFormCompetency = (props) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const dispatch = useDispatch();
  //Roles
  const userRoles = useSelector((store) => store.auth.userRoles);

  const history = useHistory();
  const {
    loaderEvalFormCompetency,
    evalFormCompetency,
    evalFormCompetencyFalla,
    saveLoaderEvalFormCompetency,
  } = useSelector((store) => store.evalFormCompetency);

  useEffect(() => {
    dispatch(getFormEvalCompeteciaById(parseInt(props.match.params.idFactor)));
  }, []);

  const onSubmit = (req, tipo_eval) => {
    if (
      req.comentario_evaluador.trim().length !== 0 ||
      req.comentario_evaluado.trim().length !== 0
    ) {
      let _req = {};
      _req.comentario_evaluador = req.comentario_evaluador;
      _req.comentario_evaluado = req.comentario_evaluado;
      dispatch(editFormEvalCompetencia(req, evalFormCompetency, tipo_eval));
    } else {
      toastr.info("El comentario no debe ir vacío");
      return;
    }
  };

  const cerrarEvaluacion = (req, tipo_eval) => {
    if (
      req.comentario_evaluador.trim().length !== 0 &&
      ((evalFormCompetency && !evalFormCompetency.comentario_evaluador) ||
        (evalFormCompetency &&
          evalFormCompetency.comentario_evaluador &&
          evalFormCompetency.comentario_evaluador.trim().length !== 0))
    ) {
      let _req = {};
      _req.comentario_evaluador = req.comentario_evaluador;
      _req.comentario_evaluado = req.comentario_evaluado;
      _req.fecha_comentario_evaluado = req.fecha_comentario_evaluado;
      _req.estado = req.estado;
      dispatch(editFormEvalCompetencia(req, evalFormCompetency, tipo_eval));
    } else {
      toastr.info("El comentario de evaluador no debe ir vacío");
      return;
    }
  };

  // const SendEmail = async () => {
  //   try {
  //     setLoadingPrint(true);
  //     const input = document.getElementById("captureAll");
  //     await html2canvas(input).then(async (canvas) => {
  //       let imgWidth = 205;
  //       let imgHeight = (canvas.height * imgWidth) / canvas.width;
  //       let pdf = jsPDF("p", "mm", [215, 354]);
  //       pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight);
  //       const _pdf = pdf.output("blob");
  //       var emailForm = new FormData();
  //       emailForm.append(
  //         "encabezado_competencia",
  //         props.match.params.idCompetencia
  //       );
  //       emailForm.append("encabezado_factor", props.match.params.idFactor);
  //       emailForm.append("archivo", _pdf);
  //       dispatch(
  //         sendNotifications(
  //           {
  //             competencia_encabezado_id: props.match.params.idCompetencia,
  //             factor_encabezado_id: props.match.params.idFactor,
  //           },
  //           evalFormCompetency.id,
  //           emailForm
  //         )
  //       );
  //       setLoadingPrint(false);
  //     });
  //   } catch (error) {
  //     console.error(error);
  //     toastr.error(messages.fileError);
  //     dispatch(
  //       sendNotifications(
  //         {
  //           competencia_encabezado_id: props.match.params.idCompetencia,
  //           factor_encabezado_id: props.match.params.idFactor,
  //         },
  //         evalFormCompetency.id,
  //         null
  //       )
  //     );
  //     setLoadingPrint(false);
  //     return null;
  //   }
  // };

  // const htmlToImg = async () => {
  //   try {
  //     setLoadingPrint(true);
  //     const input = document.getElementById("captureAll");
  //     await html2canvas(input).then(async (canvas) => {
  //       let imgWidth = 205;
  //       let imgHeight = (canvas.height * imgWidth) / canvas.width;
  //       let pdf = jsPDF("p", "mm", [215, 354]);
  //       pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight);
  //       // pdf.save("imagen blob.pdf");
  //       const _pdf = pdf.output("blob");
  //       // const filebase64 = await getBase64(_pdf);
  //       // const aFileBase = String(filebase64).split(",");
  //       var emailForm = new FormData();
  //       emailForm.append(
  //         "encabezado_competencia",
  //         props.match.params.idCompetencia
  //       );
  //       emailForm.append("encabezado_factor", props.match.params.idFactor);
  //       emailForm.append("archivo", _pdf);
  //       dispatch(sendOverviewNotifications(emailForm));
  //       setLoadingPrint(false);
  //     });
  //   } catch (error) {
  //     console.error(error);
  //     toastr.error(messages.fileError);
  //     setLoadingPrint(false);
  //     return null;
  //   }
  // };

  const SendEmail = () => {
    try {
      setLoadingPrint(true);
      document.getElementById("codigoId1").style.display = "block";
      const input = document.getElementById("captureAll");
      var emailForm = new FormData();
      emailForm.append(
        "encabezado_competencia",
        props.match.params.idCompetencia
      );
      emailForm.append("encabezado_factor", props.match.params.idFactor);
      html2canvas(input).then((canvas0) => {
        var imgWidth = 200;
        var pageHeight = 344;
        var imgHeight = (canvas0.height * imgWidth) / canvas0.width;
        var heightLeft0 = imgHeight;
        var position = 6;
        const pdf = new jsPDF("p", "mm", [215, 354]);
        heightLeft0 -= pageHeight;
        if (heightLeft0 >= 0) {
          document.getElementById("codigoId2").style.display = "block";
          const data = document.getElementById("capture");
          html2canvas(data).then((canvas) => {
            var imgWidth = 200;
            var pageHeight = 344;
            var imgHeight = (canvas.height * imgWidth) / canvas.width;
            var heightLeft = imgHeight;
            var position = 6;
            heightLeft -= pageHeight;
            if (heightLeft >= 0) {
              document.getElementById("comentEval1").style.display = "none";
              document.getElementById("comentEval2").style.display = "block";
              const dataC = document.getElementById("capture");
              html2canvas(dataC).then((canvasC) => {
                var imgWidthC = 200;
                var imgHeightC = (canvasC.height * imgWidth) / canvasC.width;
                var positionC = 6;
                pdf.addImage(
                  canvasC,
                  "PNG",
                  8,
                  positionC,
                  imgWidthC,
                  imgHeightC,
                  "",
                  "FAST"
                );
              });
            } else {
              document.getElementById("comentEval1").style.display = "block";
              document.getElementById("comentEval2").style.display = "none";
              const dataD = document.getElementById("capture");
              html2canvas(dataD).then((canvasD) => {
                var imgWidthD = 200;
                var imgHeightD = (canvasD.height * imgWidth) / canvasD.width;
                var positionD = 6;
                pdf.addImage(
                  canvasD,
                  "PNG",
                  8,
                  positionD,
                  imgWidthD,
                  imgHeightD,
                  "",
                  "FAST"
                );
              });
            }
            heightLeft -= pageHeight;

            const data3 = document.getElementById("comentarioId");
            html2canvas(data3).then((_canvas) => {
              var imgWidth2 = 200;
              var imgHeight2 = (_canvas.height * imgWidth) / _canvas.width;
              pdf.addPage();
              pdf.addImage(
                _canvas,
                "PNG",
                8,
                position,
                imgWidth2,
                imgHeight2,
                "",
                "FAST"
              );
              // pdf.save("resumen general.pdf");
              const _pdf = pdf.output("blob");
              emailForm.append("archivo", _pdf);
              dispatch(
                sendNotifications(
                  {
                    competencia_encabezado_id: props.match.params.idCompetencia,
                    factor_encabezado_id: props.match.params.idFactor,
                  },
                  evalFormCompetency.id,
                  emailForm
                )
              );
              setLoadingPrint(false);
              // document.getElementById("printId2").style.display = "block";
              // document.getElementById("printId3").style.display = "block";
              document.getElementById("codigoId1").style.display = "none";
              document.getElementById("codigoId2").style.display = "none";
              document.getElementById("codigoId3").style.display = "none";
              document.getElementById("codigoId4").style.display = "none";
            });
          });
        } else {
          pdf.addImage(
            canvas0,
            "PNG",
            8,
            position,
            imgWidth,
            imgHeight,
            "",
            "FAST"
          );
          // pdf.save("resumen general.pdf");
          const _pdf = pdf.output("blob");
          emailForm.append("archivo", _pdf);
          dispatch(
            sendNotifications(
              {
                competencia_encabezado_id: props.match.params.idCompetencia,
                factor_encabezado_id: props.match.params.idFactor,
              },
              evalFormCompetency.id,
              emailForm
            )
          );
          document.getElementById("codigoId1").style.display = "none";
          document.getElementById("codigoId2").style.display = "none";
          heightLeft0 -= pageHeight;
          setLoadingPrint(false);
        }
      });
    } catch (error) {
      console.error(error);
      toastr.error(messages.fileError);
      dispatch(
        sendNotifications(
          {
            competencia_encabezado_id: props.match.params.idCompetencia,
            factor_encabezado_id: props.match.params.idFactor,
          },
          evalFormCompetency.id,
          null
        )
      );
      setLoadingPrint(false);
      return null;
    }
  };

  const htmlToImg = () => {
    setLoadingPrint(true);
    document.getElementById("codigoId1").style.display = "block";
    const input = document.getElementById("captureAll");
    var emailForm = new FormData();
    emailForm.append(
      "encabezado_competencia",
      props.match.params.idCompetencia
    );
    emailForm.append("encabezado_factor", props.match.params.idFactor);
    html2canvas(input).then((canvas0) => {
      var imgWidth = 200;
      var pageHeight = 344;
      var imgHeight = (canvas0.height * imgWidth) / canvas0.width;
      var heightLeft0 = imgHeight;
      var position = 6;
      const pdf = new jsPDF("p", "mm", [215, 354]);
      heightLeft0 -= pageHeight;
      if (heightLeft0 >= 0) {
        document.getElementById("codigoId2").style.display = "block";
        const data = document.getElementById("capture");
        html2canvas(data).then((canvas) => {
          var imgWidth = 200;
          var pageHeight = 344;
          var imgHeight = (canvas.height * imgWidth) / canvas.width;
          var heightLeft = imgHeight;
          var position = 6;
          heightLeft -= pageHeight;
          if (heightLeft >= 0) {
            document.getElementById("comentEval1").style.display = "none";
            document.getElementById("comentEval2").style.display = "block";
            const dataC = document.getElementById("capture");
            html2canvas(dataC).then((canvasC) => {
              var imgWidthC = 200;
              var imgHeightC = (canvasC.height * imgWidth) / canvasC.width;
              var positionC = 6;
              pdf.addImage(
                canvasC,
                "PNG",
                8,
                positionC,
                imgWidthC,
                imgHeightC,
                "",
                "FAST"
              );
            });
          } else {
            document.getElementById("comentEval1").style.display = "block";
            document.getElementById("comentEval2").style.display = "none";
            const dataD = document.getElementById("capture");
            html2canvas(dataD).then((canvasD) => {
              var imgWidthD = 200;
              var imgHeightD = (canvasD.height * imgWidth) / canvasD.width;
              var positionD = 6;
              pdf.addImage(
                canvasD,
                "PNG",
                8,
                positionD,
                imgWidthD,
                imgHeightD,
                "",
                "FAST"
              );
            });
          }
          heightLeft -= pageHeight;

          const data3 = document.getElementById("comentarioId");
          html2canvas(data3).then((_canvas) => {
            var imgWidth2 = 200;
            var imgHeight2 = (_canvas.height * imgWidth) / _canvas.width;
            pdf.addPage();
            pdf.addImage(
              _canvas,
              "PNG",
              8,
              position,
              imgWidth2,
              imgHeight2,
              "",
              "FAST"
            );
            // pdf.save("resumen general.pdf");
            const _pdf = pdf.output("blob");
            emailForm.append("archivo", _pdf);
            dispatch(sendOverviewNotifications(emailForm));
            setLoadingPrint(false);
            // document.getElementById("printId2").style.display = "block";
            // document.getElementById("printId3").style.display = "block";
            document.getElementById("codigoId1").style.display = "none";
            document.getElementById("codigoId2").style.display = "none";
            document.getElementById("codigoId3").style.display = "none";
            document.getElementById("codigoId4").style.display = "none";
          });
        });
      } else {
        pdf.addImage(
          canvas0,
          "PNG",
          8,
          position,
          imgWidth,
          imgHeight,
          "",
          "FAST"
        );
        // pdf.save("resumen general.pdf");
        const _pdf = pdf.output("blob");
        emailForm.append("archivo", _pdf);
        dispatch(sendOverviewNotifications(emailForm));
        document.getElementById("codigoId1").style.display = "none";
        document.getElementById("codigoId2").style.display = "none";
        heightLeft0 -= pageHeight;
        setLoadingPrint(false);
      }
    });
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Col md="12" className="px-0 align-item-right">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 mx-3 d-flex flex-wrap justify-content-start align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              {" "}
            </Row>{" "}
            <Button
              onClick={() => history.goBack()}
              variant="link"
              className="font-weight-bold text-dark"
            >
              <i className="material-icons">arrow_back</i>
            </Button>
            <h6 className="font-weight-bold text-uppercase">
              Formulario de evaluación
            </h6>
          </div>
          <Card
            className="border border-muted rounded shadow-sm bg-white"
            style={{ border: "1px solid #ced4da" }}
          >
            <Card.Header className="card-crear text-muted d-flex flex-wrap justify-left-center align-items-left text-justify">
              <Col
                md="12"
                className="px-0 mx-auto d-flex flex-wrap justify-left-center align-items-right text-justify"
              >
                <h6 style={{ paddingTop: 8 }}>Evaluacion desempeño laboral</h6>
                <div className="px-2"></div>
                {loaderEvalFormCompetency ||
                (props.match.params.evaluationType &&
                  !props.match.params.oType &&
                  parseInt(props.match.params.evaluationType) === 2) ||
                (evalFormCompetency && !evalFormCompetency.estado) ? null : (
                  <>
                    {props.match.params.evaluationType &&
                    props.match.params.oType ? null : (
                      <>
                        <Button
                          className="rounded-pill mt-0"
                          style={{ cursor: "pointer" }}
                          disabled={
                            loadingPrint ||
                            saveLoaderEvalFormCompetency ||
                            loaderEvalFormCompetency
                          }
                          variant="warning"
                          type="button"
                          onClick={() =>
                            onSubmit(
                              {
                                comentario_evaluador: document.getElementById(
                                  "comentario_evaluador"
                                ).value,
                                comentario_evaluado: document.getElementById(
                                  "comentario_evaluado"
                                ).value,
                              },
                              evalFormCompetency.list_tipo_evaluacion[0].nombre
                            )
                          }
                        >
                          {loadingPrint ||
                          saveLoaderEvalFormCompetency ||
                          loaderEvalFormCompetency ? (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              align-items="right"
                            />
                          ) : null}
                          Guardar evaluación
                        </Button>
                      </>
                    )}
                    {/* {!evalFormCompetency ||
                    !(
                      props.match.params.evaluationType &&
                      !props.match.params.oType
                    ) ||
                    (evalFormCompetency &&
                      !(
                        evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                          "180°" ||
                        evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                          "270°" ||
                        evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                          "360°"
                      )) ? null : (
                      <>
                        <Button
                          className="rounded-pill ml-1 mt-0"
                          style={{ cursor: "pointer" }}
                          disabled={
                            loadingPrint ||
                            saveLoaderEvalFormCompetency ||
                            loaderEvalFormCompetency
                          }
                          variant="warning"
                          type="button"
                          onClick={() =>
                            cerrarEvaluacion(
                              {
                                comentario_evaluador: document.getElementById(
                                  "comentario_evaluador"
                                ).value,
                                comentario_evaluado: document.getElementById(
                                  "comentario_evaluado"
                                ).value,
                                fecha_comentario_evaluado:
                                  moment().format("YYYY-MM-DD"),
                                estado: false,
                              },
                              evalFormCompetency.list_tipo_evaluacion[0].nombre
                            )
                          }
                        >
                          {loadingPrint ||
                          saveLoaderEvalFormCompetency ||
                          loaderEvalFormCompetency ? (
                            <Spinner
                              className="mr-2"
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                              align-items="right"
                            />
                          ) : null}
                          Cerrar evaluación
                        </Button>
                      </>
                    )} */}
                    {(props.match.params.evaluationType &&
                      !props.match.params.oType) ||
                    (evalFormCompetency &&
                      evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                        "0°") ||
                    (evalFormCompetency &&
                      (evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                        "180°" ||
                        evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                          "270°" ||
                        evalFormCompetency.list_tipo_evaluacion[0].nombre ===
                          "360°")) ? null : (
                      <>
                        {evalFormCompetency && !evalFormCompetency.enviada && (
                          <Button
                            className="ml-2 rounded-pill"
                            disabled={
                              loadingPrint ||
                              saveLoaderEvalFormCompetency ||
                              loaderEvalFormCompetency
                            }
                            variant="warning"
                            type="submit"
                            onClick={() => {
                              SendEmail();
                            }}
                          >
                            {loadingPrint ||
                            saveLoaderEvalFormCompetency ||
                            loaderEvalFormCompetency ? (
                              <Spinner
                                className="mr-2"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                align-items="right"
                              />
                            ) : null}
                            Enviar evaluación
                          </Button>
                        )}
                        {evalFormCompetency && evalFormCompetency.enviada && (
                          <Button
                            variant="warning"
                            size="sm"
                            className="ml-2 rounded-pill d-flex flex-wrap justify-left-center align-items-center"
                            disabled={
                              loadingPrint ||
                              saveLoaderEvalFormCompetency ||
                              loaderEvalFormCompetency
                            }
                            onClick={() => {
                              htmlToImg();
                            }}
                          >
                            {loadingPrint ||
                            saveLoaderEvalFormCompetency ||
                            loaderEvalFormCompetency ? (
                              <div className="d-flex justify-content-center">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="mr-1 d-flex justify-content-center"
                                  size="sm"
                                />
                              </div>
                            ) : null}
                            Reenviar evaluación
                          </Button>
                        )}
                      </>
                    )}
                  </>
                )}
                <Dropdown>
                  <Dropdown.Toggle
                    variant="warning"
                    className="ml-2 rounded-pill d-flex flex-wrap justify-left-center align-items-center"
                    id="dropdown-basic"
                    disabled={
                      loadingPrint ||
                      saveLoaderEvalFormCompetency ||
                      loaderEvalFormCompetency
                    }
                  >
                    {loadingPrint ||
                    saveLoaderEvalFormCompetency ||
                    loaderEvalFormCompetency ? (
                      <div className="d-flex justify-content-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="mr-1 d-flex justify-content-center"
                          size="sm"
                        />
                      </div>
                    ) : null}
                    Menú
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {loaderEvalFormCompetency ||
                    (props.match.params.evaluationType &&
                      !props.match.params.oType) ||
                    (evalFormCompetency &&
                      !evalFormCompetency.estado) ? null : (
                      <>
                        {userRoles.length > 0 &&
                        (userRoles.includes("administrador") ||
                          userRoles.includes(
                            "Responsable_Seleccion_Contratacion"
                          )) ? (
                          <>
                            <Dropdown.Item
                              onClick={() =>
                                history.push(
                                  `/pesos-factor/${props.match.params.idFactor}`
                                )
                              }
                            >
                              Cambiar pesos
                            </Dropdown.Item>
                          </>
                        ) : null}
                      </>
                    )}
                    <Dropdown.Item
                      onClick={() =>
                        history.push(
                          props.match.params.evaluationType
                            ? `/evaluacion-desempenio/preguntas-por-competencias/${
                                props.match.params.idColab
                              }/${props.match.params.type}/${
                                props.match.params.evaluationType
                              }/${props.match.params.idCompetencia}/${
                                evalFormCompetency
                                  ? evalFormCompetency.periodicidad
                                  : null
                              }`
                            : `/evaluacion-desempenio/formulario-preguntas-competencias/${
                                props.match.params.idCompetencia
                              }/${
                                evalFormCompetency
                                  ? evalFormCompetency.periodicidad
                                  : null
                              }`
                        )
                      }
                    >
                      Ir a formulario de competencia
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() =>
                        history.push(
                          props.match.params.evaluationType
                            ? `/evaluacion-desempenio/preguntas-por-factor/${
                                props.match.params.idColab
                              }/${props.match.params.type}/${
                                props.match.params.evaluationType
                              }/${props.match.params.idFactor}/${
                                evalFormCompetency
                                  ? evalFormCompetency.periodicidad
                                  : null
                              }/${
                                evalFormCompetency
                                  ? evalFormCompetency.list_evaluado[0]
                                      .posicion[0]
                                  : null
                              }`
                            : `/evaluacion-desempenio/formulario-preguntas-factor/${
                                props.match.params.idFactor
                              }/${
                                evalFormCompetency
                                  ? evalFormCompetency.periodicidad
                                  : null
                              }/${
                                evalFormCompetency
                                  ? evalFormCompetency.list_evaluado[0]
                                      .posicion[0]
                                  : null
                              }`
                        )
                      }
                    >
                      Ir a formulario de factores
                    </Dropdown.Item>
                    {props.match.params.evaluationType &&
                    !props.match.params.oType ? null : (
                      <>
                        <Dropdown.Item
                          onClick={() =>
                            history.push(
                              `/resumen-general-de-evaluaciones/${
                                evalFormCompetency.evaluado
                              }/${evalFormCompetency.list_evaluado[0].nombre}/${
                                evalFormCompetency.list_evaluado[0].posicion[0]
                              }/${evalFormCompetency.list_evaluado[0].Funciones_List[0].descripcion.replaceAll(
                                "/",
                                "-"
                              )}/${
                                evalFormCompetency.list_evaluado[0].division
                              }/${
                                evalFormCompetency.list_evaluado[0]
                                  .Division_List[0].descripcion
                              }/${props.match.params.idFactor}/${
                                props.match.params.idEmpresa
                              }`
                            )
                          }
                        >
                          Ir a resultados
                        </Dropdown.Item>
                      </>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Card.Header>
            <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
              <Row className="justify-content-sm-center align-items-center flex-nowrap">
                <Col md="12">
                  <Row className="mb-3">
                    <Form.Group md="4" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Empresa
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    value={
                                      evalFormCompetency &&
                                      evalFormCompetency.evaluado
                                        ? evalFormCompetency.list_evaluado[0]
                                            .empresa[0]
                                        : ""
                                    }
                                    //   value={evalFormCompetency.}
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                  ></Form.Control>
                                </Col>
                                {loaderEvalFormCompetency ||
                                  (saveLoaderEvalFormCompetency && (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  ))}
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="4" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Fecha actual
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    value={
                                      evalFormCompetency
                                        ? moment(
                                            evalFormCompetency.fecha_actualizacion
                                          ).format("DD/MM/YYYY")
                                        : ""
                                    }
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                  ></Form.Control>
                                </Col>
                                {loaderEvalFormCompetency ||
                                  (saveLoaderEvalFormCompetency && (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  ))}
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="4" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Tipo evaluación
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency
                                            .list_tipo_evaluacion[0].nombre
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>
                  </Row>

                  <Row className="mb-0">
                    <Form.Group md="4" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Fecha evaluación
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency &&
                                      evalFormCompetency.fecha_evaluacion
                                        ? moment(
                                            evalFormCompetency.fecha_evaluacion
                                          ).format("DD/MM/YYYY")
                                        : "No realizada"
                                    }
                                  ></Form.Control>
                                </Col>
                                {loaderEvalFormCompetency ||
                                  (saveLoaderEvalFormCompetency && (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  ))}
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="4" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Periodo
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? "Periodo" +
                                          " " +
                                          evalFormCompetency.periodo
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                                {loaderEvalFormCompetency ||
                                  (saveLoaderEvalFormCompetency && (
                                    <Col sm={1}>
                                      <Spinner animation="border" size="sm" />
                                    </Col>
                                  ))}
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="4" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Frecuencia
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency
                                            .list_periodicidad[0]
                                            .list_frecuencia[0].nombre
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        {/* separacion */}
        <Col md="12" className="px-0 mx-auto mt-4">
          <Card
            className="border border-muted rounded shadow-sm bg-white"
            style={{ border: "1px solid #ced4da" }}
          >
            <Card.Header className="card-crear text-muted d-flex flex-wrap justify-left-center align-items-left text-justify">
              <h6>Datos del evaluado</h6>
            </Card.Header>
            <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
              <Row className="justify-content-sm-center align-items-center flex-nowrap">
                <Col md="12">
                  <Row className="mb-0">
                    <Form.Group
                      md="6"
                      xs="auto"
                      className="md-mb-2 sm-mb-0 px-0"
                      as={Col}
                    >
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Nombre
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency.list_evaluado[0]
                                            .nombre
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="6" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Función
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency &&
                                      evalFormCompetency.evaluado
                                        ? evalFormCompetency.list_evaluado[0]
                                            .Funciones_List[0].descripcion
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="6" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Departamento
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency.list_evaluado[0]
                                            .Unidad_Organizativa_List[0].nombre
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Col md="12" className="mb-0 px-0 mt-3">
                      <Row className="mb-0">
                        <Form.Label column xs="auto">
                          Comentario
                        </Form.Label>
                        <Col md={10} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    type="text"
                                    name="comentario_evaluado"
                                    id="comentario_evaluado"
                                    as="textarea"
                                    disabled={
                                      loaderEvalFormCompetency ||
                                      (props.match.params.evaluationType &&
                                        parseInt(
                                          props.match.params.evaluationType
                                        ) === 2) ||
                                      (evalFormCompetency &&
                                        !evalFormCompetency.estado) ||
                                      (evalFormCompetency &&
                                        evalFormCompetency
                                          .list_tipo_evaluacion[0].nombre ===
                                          "90°") ||
                                      props.match.params.jefe ||
                                      (evalFormCompetency &&
                                        (evalFormCompetency
                                          .list_tipo_evaluacion[0].nombre ===
                                          "180°" ||
                                          evalFormCompetency
                                            .list_tipo_evaluacion[0].nombre ===
                                            "270°" ||
                                          evalFormCompetency
                                            .list_tipo_evaluacion[0].nombre ===
                                            "360°"))
                                    }
                                    defaultValue={
                                      evalFormCompetency
                                        ? evalFormCompetency.comentario_evaluado
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                              <Col>
                                <p className="text-muted">**Campo requerido </p>
                              </Col>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        {/*separacion*/}
        <br></br>
        <Col md="12" className="px-0 mx-auto">
          <Card
            className="border border-muted rounded shadow-sm bg-white"
            style={{ border: "1px solid #ced4da" }}
          >
            <Card.Header className="card-crear text-muted d-flex flex-wrap justify-left-center align-items-left text-justify">
              <h6>Datos del evaluador</h6>
            </Card.Header>
            <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
              <Row className="justify-content-sm-center align-items-center flex-nowrap">
                <Col md="12">
                  <Row className="mb-0">
                    <Form.Group
                      md="6"
                      xs="auto"
                      className="md-mb-2 sm-mb-0 px-0"
                      as={Col}
                    >
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Nombre
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col md="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency.list_evaluador[0]
                                            .nombre
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="6" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Función
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency.list_evaluador[0]
                                            .Funciones_List[0].descripcion
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Form.Group md="6" xs="auto" className="mb-0 px-0" as={Col}>
                      <Row className="mb-0">
                        <Form.Label column md="3" xs="auto">
                          Departamento
                        </Form.Label>
                        <Col md={8} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    className="rounded-pill"
                                    type="text"
                                    disabled
                                    value={
                                      evalFormCompetency
                                        ? evalFormCompetency.list_evaluador[0]
                                            .Unidad_Organizativa_List[0].nombre
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    <Col md="12" className="mb-0 px-0 mt-3">
                      <Row className="mb-0">
                        <Form.Label column xs="auto">
                          Comentario
                        </Form.Label>
                        <Col md={10} xs="auto">
                          {loaderEvalFormCompetency ||
                          saveLoaderEvalFormCompetency ? (
                            <div className="d-flex justify-content-center">
                              <Spinner
                                animation="border"
                                role="status"
                                className="d-flex justify-content-center"
                              />
                            </div>
                          ) : (
                            <>
                              <Row>
                                <Col sm="12">
                                  <Form.Control
                                    type="text"
                                    id="comentario_evaluador"
                                    nambe="comentario_evaluador"
                                    as="textarea"
                                    disabled={
                                      loaderEvalFormCompetency ||
                                      (props.match.params.evaluationType &&
                                        parseInt(
                                          props.match.params.evaluationType
                                        ) === 2) ||
                                      (evalFormCompetency &&
                                        !evalFormCompetency.estado) ||
                                      (evalFormCompetency &&
                                        evalFormCompetency
                                          .list_tipo_evaluacion[0].nombre ===
                                          "0°") ||
                                      props.match.params.jefe
                                    }
                                    defaultValue={
                                      evalFormCompetency
                                        ? evalFormCompetency.comentario_evaluador
                                        : ""
                                    }
                                  ></Form.Control>
                                </Col>
                              </Row>
                              <Col>
                                <p className="text-muted">**Campo requerido </p>
                              </Col>
                            </>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
        {!!evalFormCompetencyFalla && (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            {evalFormCompetencyFalla}
          </Alert>
        )}
      </div>
      {/* <ResumenColaborador idEvaluacion={props.match.params.idFactor} /> */}
      <ResumenColaboradorCompleto idEvaluacion={props.match.params.idFactor} />
    </>
  );
};

export default EvalFormCompetency;
